import * as actionTypes from "./actionTypes";
import {collections,documents,constants} from "../../firebase/firestoreNameSpaces";
import {firebase} from "../../firebase/index"

const checkCategoryExist = (categories,newcategoryname)=>{
  if (!categories) {
      return alert("categories is null");
    }
    let res = categories.filter(
      (categoryObj) => categoryObj.categoryName === newcategoryname.trim()
    ).length;
    if (res) {
      return true
     
    }else{
        return false
    }
}
const checkSubcategoryExist = (subcategories,newsubcategoryname)=>{
  let exists = subcategories.filter(sObj=>sObj.name===newsubcategoryname).length
  if(exists){
      return true
  }else{
      return false
  }
}

export const onAddCategory = (category) => {
  
  return async (dispatch,getState) => {
  
    try { 
 
  
      let categories = getState().category.categories;
    
      //############################
      let exist = checkCategoryExist(categories,category.categoryName)
      if(exist){
          return  alert("Category Already exists, please choose different name");
      }
     
      dispatch({
        type: actionTypes.UTILITY_CONTROLS,
        payload: { loading: true, editCategoryBtnLoading: true },
      });
      let db = firebase.firestore();
      const batch = db.batch();
      
    let categoryId = db.collection(collections.CATEGORIES).doc().id; 
      category["id"] = categoryId;
    
     let c1 = db.collection(collections.CATEGORIES).doc(categoryId)
    batch.set(c1,category)
     let c2 = db.collection(collections.K5METADATA).doc(documents.CATEGORIES)
     batch.set(c2,{ [categoryId]: category }, { merge: true })

    await batch.commit()
    dispatch({
      type: actionTypes.UTILITY_CONTROLS,
      payload: { loading: false, editCategoryBtnLoading: false },
    });
    alert("Category Added Successfully...")
     

    } catch (err) {
        dispatch({
          type: actionTypes.UTILITY_CONTROLS,
          payload: { loading: false, editCategoryBtnLoading: false },
        });
          return alert(err)
    }

  };
};

export const onCategoryNameRename = (category) => {
 
  return async (dispatch,getState) => {
    try{
     
  
      let categories = getState().category.categories;

      let newcategoryname = category.categoryName;
      let categoryId = category.id;

      //#####################
      let exist = checkCategoryExist(categories,newcategoryname);
      if(exist){
          return alert("Please Enter a Different category Name")
      }
      dispatch({
        type: actionTypes.UTILITY_CONTROLS,
        payload: { editCategoryNameLoading: true },
      });
      let db = firebase.firestore();
      let batch = db.batch();
      let c1 = db.collection(collections.K5METADATA).doc(documents.CATEGORIES)
      batch.set(c1,{[categoryId]:{categoryName:newcategoryname}},{merge:true})
      let c2 = db.collection(collections.CATEGORIES).doc(categoryId)
      batch.update(c2,{categoryName:newcategoryname})
      await batch.commit()
      dispatch({
        type: actionTypes.UTILITY_CONTROLS,
        payload: { editCategoryNameLoading: false },
      });
      alert("Category Renamed Successfully")
      
      
  }catch(error){
      dispatch({
        type: actionTypes.UTILITY_CONTROLS,
        payload: { editCategoryNameLoading: false },
      });
      return alert(error)
  }
   
  };


};

export const onDeleteCategory = (categoryId) => {
  
  return async (dispatch) => {
    
    try{
      dispatch({
        type: actionTypes.UTILITY_CONTROLS,
        payload: { delCategoryBtnLoading: true },
      });
     
      let db = firebase.firestore();
      let batch = db.batch();
      let c1 = db.collection(collections.K5METADATA).doc(documents.CATEGORIES);
      batch.set(c1,{[categoryId]:firebase.firestore.FieldValue.delete()},{merge:true})
      let c2 = db.collection(collections.CATEGORIES).doc(categoryId)
      batch.delete(c2)
      document.getElementById(`d${categoryId}`).click()
      await batch.commit();
      // window.location.reload()
      // return alert("Category Deleted Successfully")
 }catch(error){
  dispatch({
    type: actionTypes.UTILITY_CONTROLS,
    payload: { delCategoryBtnLoading: true },
  });
     return alert(error)
 }

  }; 
};

export const onSubCategoryNameRename = (newSubCategory,category) => {
 
  return async(dispatch) => {
  
    try{
 
      let categoryId = category.id;
      let newsubcategoryname = newSubCategory.subCategoryName
      let subcategoryId = newSubCategory.id;
    
      //###################
      if(checkSubcategoryExist(category.subcategories,newsubcategoryname)){
          return alert("Please Enter different Subcategory")
      }
      dispatch({
        type: actionTypes.UTILITY_CONTROLS,
        payload: { editSubCategoryNameLoading: true },
      });
      let db = firebase.firestore();
      let batch = db.batch();
      let c1 = db.collection(collections.K5METADATA).doc(documents.CATEGORIES)
      batch.set(c1,{[categoryId]:{[constants.SUBCATEGORIES]:{[subcategoryId]:newsubcategoryname}}},{merge:true})
      let c2 = db.collection(collections.CATEGORIES).doc(categoryId)
      batch.set(c2,{[constants.SUBCATEGORIES]:{[subcategoryId]:newsubcategoryname}},{merge:true})
      await batch.commit();
      dispatch({
        type: actionTypes.UTILITY_CONTROLS,
        payload: { editSubCategoryNameLoading: true },
      });
      return alert("Subcategory Rename Successfully")
  
  }catch(error){
    dispatch({
      type: actionTypes.UTILITY_CONTROLS,
      payload: { editSubCategoryNameLoading: true },
    });
  
      return alert(error)
  }
  
  };
};

export const onDeleteSubCategory = (subcategoryId, categoryId) => {
 
  return async (dispatch) => {
   
    
    try{ 
 
      dispatch({
        type: actionTypes.UTILITY_CONTROLS,
        payload: { delSubCategoryBtnLoading: true },
      });

      let db = firebase.firestore();
      let batch = db.batch();

      let c1 = db.collection(collections.K5METADATA).doc(documents.CATEGORIES)
      batch.set(c1,{[categoryId]:{subcategories:{[subcategoryId]:firebase.firestore.FieldValue.delete()}}},{merge:true});
      let c2 = db.collection(collections.CATEGORIES).doc(categoryId)
      batch.set(c2,{subcategories:{[subcategoryId]:firebase.firestore.FieldValue.delete()}},{merge:true})
      document.getElementById(`cd${categoryId}${subcategoryId}`).click()
      await batch.commit()
      dispatch({
        type: actionTypes.UTILITY_CONTROLS,
        payload: { delSubCategoryBtnLoading: false },
      });
      
      // return alert("Subcategory Deleted Successfully")
  }catch(error){
    dispatch({
      type: actionTypes.UTILITY_CONTROLS,
      payload: { delSubCategoryBtnLoading: false },
    });
      return alert(error)
  }


  };
};

export const onEditCategory = (category) => {
  return async (dispatch) => {
    dispatch({
      type: actionTypes.UTILITY_CONTROLS,
      payload: { loading: true, editCategoryBtnLoading: true },
    });
    console.log(category);
    dispatch({
      type: actionTypes.UTILITY_CONTROLS,
      payload: { loading: false, editCategoryBtnLoading: false },
    });
  };
};
 